import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface CloseFollowUpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pending?: boolean;
  onSubmit: (reason: string) => void;
  /** Forhåndsutfylt grunn, f.eks. notatet fra samtalen. */
  defaultReason?: string | null;
}

/** Avslutt uten neste steg: grunnen er påkrevd og lagres på oppfølgingen. */
export default function CloseFollowUpDialog({ open, onOpenChange, pending, onSubmit, defaultReason }: CloseFollowUpDialogProps) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (open) setReason(defaultReason ?? "");
  }, [open, defaultReason]);
  const valid = reason.trim().length > 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Avslutt oppfølgingen</DialogTitle>
          <DialogDescription>Skriv hvorfor den ikke skal følges opp videre.</DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (valid) onSubmit(reason.trim());
          }}
        >
          <div className="space-y-1.5 py-2">
            <Label htmlFor="close-reason">Grunn</Label>
            <Textarea id="close-reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={4} autoFocus />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Avbryt
            </Button>
            <Button type="submit" disabled={!valid || pending}>
              {pending ? "Avslutter ..." : "Avslutt oppfølging"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
